export default __webpack_public_path__ + "resources/icons/n421-6e25.webp";